// Shared presentation labels; decisions always come from Final Decision V1.
export const FINAL_DECISION_LABELS = { ENTER: 'ورود', READY: 'آماده ورود', WAIT: 'صبر', REDUCE_RISK: 'کاهش ریسک', EXIT: 'خروج' };
